const address = "0x6a89b05f2c0ce1332d3b013cb69634d55033ac0f" as `0x${string}`;
const betaAddress =
  "0xeb7c4AbDA72675222b6Bc469809E039f19FbfE10" as `0x${string}`;

const rendererAddress = (id: number) => {
  if (id > 11) return address;
  if (id === 11) return "0x66c63dC5ECA7CD6c31a661cBB1bb43f8A1e7406f";
  return betaAddress;
};

const chainId = 8453 as const;
const abi = [
  {
    type: "function",
    name: "customTheme",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContract",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_themes",
        type: "address[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "NotOwnerOrDelegate",
    type: "error",
  },
  {
    inputs: [],
    name: "DELEGATE_REGISTRY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "adBoards",
    outputs: [
      {
        internalType: "uint32",
        name: "width",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "height",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "x",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "y",
        type: "uint32",
      },
      {
        internalType: "int32",
        name: "rotation",
        type: "int32",
      },
      {
        internalType: "string",
        name: "src",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "customTracks",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "d",
    outputs: [
      {
        internalType: "string",
        name: "_d",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "getAds",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "width",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "height",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "x",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "y",
            type: "uint32",
          },
          {
            internalType: "int32",
            name: "rotation",
            type: "int32",
          },
          {
            internalType: "string",
            name: "src",
            type: "string",
          },
        ],
        internalType: "struct TrackRenderer.AdUnit[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "greenFlag",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nftContract",
    outputs: [
      {
        internalType: "contract IERC721A",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "raceResultAds",
    outputs: [
      {
        internalType: "string",
        name: "src",
        type: "string",
      },
      {
        internalType: "string",
        name: "href",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "width",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "height",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "x",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "y",
            type: "uint32",
          },
          {
            internalType: "int32",
            name: "rotation",
            type: "int32",
          },
          {
            internalType: "string",
            name: "src",
            type: "string",
          },
        ],
        internalType: "struct TrackRenderer.AdUnit[]",
        name: "ads",
        type: "tuple[]",
      },
    ],
    name: "setAds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "src",
            type: "string",
          },
          {
            internalType: "string",
            name: "href",
            type: "string",
          },
        ],
        internalType: "struct TrackRenderer.RaceResultAd",
        name: "ad",
        type: "tuple",
      },
    ],
    name: "setRaceResultAd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "trackData",
        type: "bytes",
      },
    ],
    name: "setTrack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "svg",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export default { abi, address, betaAddress, chainId, rendererAddress };
